import React, { useState, useEffect, useRef } from 'react';
import Header from "./Layout/Header";
import { Link } from 'react-router-dom';
import LeftSideBar from "./Layout/LeftSideBar";
import Footer from "./Layout/Footer";
import { SystemUrl } from '../App';
import { trans } from "./utils";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import logo_iassets from '../assets/img/iAssets.png';
import NavigateTop from './General/NavigateTop';
import HeaderContent from './General/HeaderContent';

const Template = (data) => {

    const [asideVisible, setAsideVisible] = useState(false);
    const [showMenu, setShowMenu] = useState(false);
    const headerRef = useRef(null);
    const toggleAside = () => {
        setAsideVisible(!asideVisible);
    };
    const toggleMenu = () => {
        setShowMenu(!showMenu);
    };

    //Render Component
    var ComponentToRender = require('./' + data.getfolder + '/' + data.getaction).default;
    //Get Module Variables FROM API
    let GetModuleData = JSON.parse(localStorage.getItem(data.getmodule)) || data.getmodule;
    //Dashboard Has no Variables
    if (!GetModuleData) {
        GetModuleData = {}
        GetModuleData.name_en = 'Dashboard';
    }
    let SystemTitle = localStorage.getItem('SystemTitle') ? localStorage.getItem('SystemTitle') : "iAssets";
    let PageModuleTitle = trans(GetModuleData.name_en) ? trans(GetModuleData.name_en) : "Dashboard";

    const folder = data.getfolder
    useEffect(() => {
        document.title = SystemTitle + " | " + PageModuleTitle + " - " + data.getaction
        window.$('.tooltip').tooltip('hide');
        window.$('[data-toggle="tooltip"]').tooltip();
    })

    useEffect(() => {
        const handleClickOutside = (event) => {
          if (headerRef.current && !headerRef.current.contains(event.target)) {
            setShowMenu(false);
          }
        };
    
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
          document.removeEventListener('mousedown', handleClickOutside);
        };
      }, []);

    return (
        <>
            {folder !== "FormBuilder" ? (
            <>
                <div id="kt_header_mobile" className="header-mobile header-mobile-fixed">
                    <Link to="/">
                        <img alt="Logo" src={logo_iassets} className="logo-default max-h-30px" />
                    </Link>
                    <div className="d-flex align-items-center">
                        <button className="btn p-0 burger-icon burger-icon-left rounded-0" onClick={toggleMenu}>
                            <span></span>
                        </button>
                        <button className="btn btn-hover-icon-primary p-0 ml-5" id="kt_sidebar_mobile_toggle">
                            <span className="svg-icon svg-icon-xl"></span>
                        </button>
                        <button className="btn btn-hover-icon-primary p-0 ml-2" onClick={toggleAside}>
                            <span className="svg-icon svg-icon-xl">
                                <svg viewBox="0 0 24 24"><path fill="none" d="M0 0h24v24H0z"/><path fill="#000" opacity=".3" d="M12 11c-2.21 0-4-1.79-4-4s1.79-4 4-4c2.21 0 4 1.79 4 4 0 2.21-1.79 4-4 4zm-9 9.2c.39-4.77 9.61-7.2 9-7.2 4.77 0 8.7 2.29 8.99 7.2C21 20.46 20.5 21 19.75 21c-3.51 0-8.72 0-16.02 0z"/></svg>
                            </span>
                        </button>
                    </div>
                </div>
                <div className="d-flex flex-column flex-root">
                    <div className="d-flex flex-row flex-column-fluid page">
                        <LeftSideBar  asideVisible={asideVisible}></LeftSideBar>
                        <div className="d-flex flex-column flex-row-fluid wrapper" id="kt_wrapper">
                            <Header headerRef={headerRef} showMenu={showMenu}></Header>
                            <HeaderContent GetModuleData={GetModuleData} data={data} SystemUrl={SystemUrl} ComponentToRender={ComponentToRender} />
                            <Footer></Footer>
                        </div>
                    </div>
                </div>
                <NavigateTop/>
            </>) :
                <ComponentToRender CurrentModule={data.getmodule} SystemUrl={SystemUrl} />
            }
            <ToastContainer />
        </>
    )
}
export default Template;
